import { VoidFunctionComponent } from 'react';
import { Icon } from 'components/elements';
import { StyledIconButton } from './IconButton.styled';
import { IconButtonProps } from './types';

export const IconButton: VoidFunctionComponent<IconButtonProps> = props => {
  const { icon, ...rest } = props;

  return (
    <StyledIconButton {...rest}>
      <Icon name={icon} />
    </StyledIconButton>
  );
};
